export default {
  Region: 'ap-northeast-1',
  UserPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
  ClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
  IdentityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID
}
